const COLLECTION_LIST_GET = 'COLLECTION_LIST_GET'
const COLLECTION_LIST_GET_SUCCESS = 'COLLECTION_LIST_GET_SUCCESS'
const COLLECTION_LIST_GET_ERROR = 'COLLECTION_LIST_GET_ERROR'
const CREATE_COLLECTION = 'CREATE_COLLECTION'
const CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS'
const CREATE_COLLECTION_ERROR = 'CREATE_COLLECTION_ERROR'
const GET_COLLECTION = 'GET_COLLECTION'
const GET_COLLECTION_SUCCESS = 'GET_COLLECTION_SUCCESS'
const GET_COLLECTION_ERROR = 'GET_COLLECTION_ERROR'
const SET_PAGE_VIEW = 'SET_PAGE_VIEW'
const DELETE_COLLECTION = 'DELETE_COLLECTION'
const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS'
const DELETE_COLLECTION_ERROR = 'DELETE_COLLECTION_ERROR'
const GET_COLLECTION_COURSE_LIST = 'GET_COLLECTION_COURSE_LIST'
const GET_COLLECTION_COURSE_LIST_SUCCESS = 'GET_COLLECTION_COURSE_LIST_SUCCESS'
const GET_COLLECTION_COURSE_LIST_ERROR = 'GET_COLLECTION_COURSE_LIST_ERROR'
const COURSE_DELETE = 'COURSE_DELETE'
const COURSE_DELETE_SUCCESS = 'COURSE_DELETE_SUCCESS'
const COURSE_DELETE_ERROR = 'COURSE_DELETE_ERROR'
const EDIT_COURSE_COLLECTION_INDEX = 'EDIT_COURSE_COLLECTION_INDEX'
const EDIT_COURSE_COLLECTION_INDEX_SUCCESS =
  'EDIT_COURSE_COLLECTION_INDEX_SUCCESS'
const EDIT_COURSE_COLLECTION_INDEX_ERROR = 'EDIT_COURSE_COLLECTION_INDEX_ERROR'
const COURSE_CLONE = 'COURSE_CLONE'
const COURSE_CLONE_SUCCESS = 'COURSE_CLONE_SUCCESS'
const COURSE_CLONE_ERROR = 'COURSE_CLONE_ERROR'
const COURSE_TRANSLATE = 'COURSE_TRANSLATE'
const COURSE_TRANSLATE_SUCCESS = 'COURSE_TRANSLATE_SUCCESS'
const COURSE_TRANSLATE_ERROR = 'COURSE_TRANSLATE_ERROR'
const COURSE_TRANSLATION_COMPLETE = 'COURSE_TRANSLATION_COMPLETE'
const GET_COLLECTION_SETTINGS = 'GET_COLLECTION_SETTINGS'
const GET_COLLECTION_SETTINGS_SUCCESS = 'GET_COLLECTION_SETTINGS_SUCCESS'
const GET_COLLECTION_SETTINGS_ERROR = 'GET_COLLECTION_SETTINGS_ERROR'
const PATCH_COLLECTION_SETTINGS = 'PATCH_COLLECTION_SETTINGS'
const PATCH_COLLECTION_SETTINGS_SUCCESS = 'PATCH_COLLECTION_SETTINGS_SUCCESS'
const PATCH_COLLECTION_SETTINGS_ERROR = 'PATCH_COLLECTION_SETTINGS_ERROR'
const PATCH_PRICE = 'PATCH_PRICE'
const PATCH_PRICE_SUCCESS = 'PATCH_PRICE_SUCCESS'
const PATCH_PRICE_ERROR = 'PATCH_PRICE_ERROR'
const PATCH_COLLECTION_PAYMENT_MESSAGES = 'PATCH_COLLECTION_PAYMENT_MESSAGES'
const PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS =
  'PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS'
const PATCH_COLLECTION_PAYMENT_MESSAGES_ERROR =
  'PATCH_COLLECTION_PAYMENT_MESSAGES_ERROR'
const PATCH_COURSE_COLLECTION = 'PATCH_COURSE_COLLECTION'
const PATCH_COURSE_COLLECTION_SUCCESS = 'PATCH_COURSE_COLLECTION_SUCCESS'
const PATCH_COURSE_COLLECTION_ERROR = 'PATCH_COURSE_COLLECTION_ERROR'

const GET_COLLECTION_LANDING_PAGE = 'GET_COLLECTION_LANDING_PAGE'
const GET_COLLECTION_LANDING_PAGE_SUCCESS =
  'GET_COLLECTION_LANDING_PAGE_SUCCESS'
const GET_COLLECTION_LANDING_PAGE_ERROR = 'GET_COLLECTION_LANDING_PAGE_ERROR'
const PATCH_COLLECTION_LANDING_PAGE = 'PATCH_COLLECTION_LANDING_PAGE'
const PATCH_COLLECTION_LANDING_PAGE_SUCCESS =
  'PATCH_COLLECTION_LANDING_PAGE_SUCCESS'
const PATCH_COLLECTION_LANDING_PAGE_ERROR =
  'PATCH_COLLECTION_LANDING_PAGE_ERROR'

const INVITE_COLLABORATOR = 'INVITE_COLLABORATOR'
const INVITE_COLLABORATOR_SUCCESS = 'INVITE_COLLABORATOR_SUCCESS'
const INVITE_COLLABORATOR_ERROR = 'INVITE_COLLABORATOR_ERROR'

const GET_COLLECTION_COLLABORATORS_LIST = 'GET_COLLECTION_COLLABORATORS_LIST'
const GET_COLLECTION_COLLABORATORS_LIST_SUCCESS =
  'GET_COLLECTION_COLLABORATORS_LIST_SUCCESS'
const GET_COLLECTION_COLLABORATORS_LIST_ERROR =
  'GET_COLLECTION_COLLABORATORS_LIST_ERROR'

const UPDATE_COLLECTION_COLLABORATOR = 'UPDATE_COLLECTION_COLLABORATOR'
const UPDATE_COLLECTION_COLLABORATOR_SUCCESS =
  'UPDATE_COLLECTION_COLLABORATOR_SUCCESS'
const UPDATE_COLLECTION_COLLABORATOR_ERROR =
  'UPDATE_COLLECTION_COLLABORATOR_ERROR'

const DELETE_COLLECTION_COLLABORATOR = 'DELETE_COLLECTION_COLLABORATOR'
const DELETE_COLLECTION_COLLABORATOR_SUCCESS =
  'DELETE_COLLECTION_COLLABORATOR_SUCCESS'
const DELETE_COLLECTION_COLLABORATOR_ERROR =
  'DELETE_COLLECTION_COLLABORATOR_ERROR'

const FILTER_COLLABORATION_COLLECTION_LIST =
  'FILTER_COLLABORATION_COLLECTION_LIST'
const FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS =
  'FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS'
const FILTER_COLLABORATION_COLLECTION_LIST_ERROR =
  'FILTER_COLLABORATION_COLLECTION_LIST_ERROR'

const ACCEPT_INVITATION_COLLABORATION = 'ACCEPT_INVITATION_COLLABORATION'
const ACCEPT_INVITATION_COLLABORATION_SUCCESS =
  'ACCEPT_INVITATION_COLLABORATION_SUCCESS'
const ACCEPT_INVITATION_COLLABORATION_ERROR =
  'ACCEPT_INVITATION_COLLABORATION_ERROR'

const SET_VIEW_MODE = 'SET_VIEW_MODE'

const DELETE_COLLECTION_INVITATION = 'DELETE_COLLECTION_INVITATION'
const DELETE_COLLECTION_INVITATION_SUCCESS =
  'DELETE_COLLECTION_INVITATION_SUCCESS'
const DELETE_COLLECTION_INVITATION_ERROR = 'DELETE_COLLECTION_INVITATION_ERROR'

const COLLECTION_SHOWCASE = 'COLLECTION_SHOWCASE'
const COLLECTION_SHOWCASE_SUCCESS = 'COLLECTION_SHOWCASE_SUCCESS'
const COLLECTION_SHOWCASE_ERROR = 'COLLECTION_SHOWCASE_ERROR'

const SET_COLLECTION_TAGS = 'SET_COLLECTION_TAGS'
const SET_COLLECTION_TAGS_SUCCESS = 'SET_COLLECTION_TAGS_SUCCESS'
const SET_COLLECTION_TAGS_ERROR = 'SET_COLLECTION_TAGS_ERROR'

const COLLECTION_DUPLICATING = 'COLLECTION_DUPLICATING'
const COLLECTION_DUPLICATION_COMPLETE = 'COLLECTION_DUPLICATION_COMPLETE'

export {
  COLLECTION_LIST_GET,
  COLLECTION_LIST_GET_SUCCESS,
  COLLECTION_LIST_GET_ERROR,
  CREATE_COLLECTION,
  CREATE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_ERROR,
  GET_COLLECTION,
  GET_COLLECTION_SUCCESS,
  GET_COLLECTION_ERROR,
  SET_PAGE_VIEW,
  DELETE_COLLECTION,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_ERROR,
  GET_COLLECTION_COURSE_LIST,
  GET_COLLECTION_COURSE_LIST_SUCCESS,
  GET_COLLECTION_COURSE_LIST_ERROR,
  COURSE_DELETE,
  COURSE_DELETE_SUCCESS,
  COURSE_DELETE_ERROR,
  EDIT_COURSE_COLLECTION_INDEX,
  EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
  EDIT_COURSE_COLLECTION_INDEX_ERROR,
  COURSE_CLONE,
  COURSE_CLONE_SUCCESS,
  COURSE_CLONE_ERROR,
  COURSE_TRANSLATE,
  COURSE_TRANSLATE_SUCCESS,
  COURSE_TRANSLATE_ERROR,
  COURSE_TRANSLATION_COMPLETE,
  GET_COLLECTION_SETTINGS,
  GET_COLLECTION_SETTINGS_SUCCESS,
  GET_COLLECTION_SETTINGS_ERROR,
  PATCH_COLLECTION_SETTINGS,
  PATCH_COLLECTION_SETTINGS_SUCCESS,
  PATCH_COLLECTION_SETTINGS_ERROR,
  PATCH_PRICE,
  PATCH_PRICE_SUCCESS,
  PATCH_PRICE_ERROR,
  PATCH_COLLECTION_PAYMENT_MESSAGES,
  PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS,
  PATCH_COLLECTION_PAYMENT_MESSAGES_ERROR,
  PATCH_COURSE_COLLECTION,
  PATCH_COURSE_COLLECTION_SUCCESS,
  PATCH_COURSE_COLLECTION_ERROR,
  GET_COLLECTION_LANDING_PAGE,
  GET_COLLECTION_LANDING_PAGE_SUCCESS,
  GET_COLLECTION_LANDING_PAGE_ERROR,
  PATCH_COLLECTION_LANDING_PAGE,
  PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
  PATCH_COLLECTION_LANDING_PAGE_ERROR,
  INVITE_COLLABORATOR,
  INVITE_COLLABORATOR_SUCCESS,
  INVITE_COLLABORATOR_ERROR,
  GET_COLLECTION_COLLABORATORS_LIST,
  GET_COLLECTION_COLLABORATORS_LIST_SUCCESS,
  GET_COLLECTION_COLLABORATORS_LIST_ERROR,
  UPDATE_COLLECTION_COLLABORATOR,
  UPDATE_COLLECTION_COLLABORATOR_SUCCESS,
  UPDATE_COLLECTION_COLLABORATOR_ERROR,
  DELETE_COLLECTION_COLLABORATOR,
  DELETE_COLLECTION_COLLABORATOR_SUCCESS,
  DELETE_COLLECTION_COLLABORATOR_ERROR,
  FILTER_COLLABORATION_COLLECTION_LIST,
  FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS,
  FILTER_COLLABORATION_COLLECTION_LIST_ERROR,
  ACCEPT_INVITATION_COLLABORATION,
  ACCEPT_INVITATION_COLLABORATION_SUCCESS,
  ACCEPT_INVITATION_COLLABORATION_ERROR,
  SET_VIEW_MODE,
  DELETE_COLLECTION_INVITATION,
  DELETE_COLLECTION_INVITATION_SUCCESS,
  DELETE_COLLECTION_INVITATION_ERROR,
  COLLECTION_SHOWCASE,
  COLLECTION_SHOWCASE_SUCCESS,
  COLLECTION_SHOWCASE_ERROR,
  SET_COLLECTION_TAGS,
  SET_COLLECTION_TAGS_SUCCESS,
  SET_COLLECTION_TAGS_ERROR,
  COLLECTION_DUPLICATING,
  COLLECTION_DUPLICATION_COMPLETE,
}
